// @flow

const DataTypes = {
  boolean: 'Boolean',
  date: 'Date',
  fuzzyDate: 'FuzzyDate',
  number: 'Number',
  richText: 'RichText',
  select: 'Select',
  string: 'String',
  text: 'Text'
};

export default {
  DataTypes
};
